import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const viewportConfig = { 
  threshold: 0.1,
  triggerOnce: false,
  rootMargin: "-50px 0px"
};

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.15,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const ContentSection = ({ description, features }) => {
  const [ref, inView] = useInView(viewportConfig);
  const controls = useAnimation();

  React.useEffect(() => {
    controls.start(inView ? "visible" : "hidden");
  }, [controls, inView]);

  return (
    <Box
      ref={ref}
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
      sx={{ 
        width: '100%',
        py: 8
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          width: '100%'
        }}
      >
        <Box
        component={motion.div}
        variants={itemVariants}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="body1"
          sx={{ color: '#666', lineHeight: 1.8, fontSize: '20px' }}
        >
          {description}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {features.map((feature, index) => (
            <Box
            key={index}
            component={motion.div}
            variants={itemVariants}
            custom={index}
            sx={{
                display: 'flex',
                gap: 2,
                alignItems: 'flex-start'
            }}
            >
            <Box sx={{ 
                color: '#64B5F6',
                mt: 0.5
            }}>
                <ArrowForwardIcon />
            </Box>
            <Box>
                <Typography variant="h6" sx={{ 
                color: '#1A1A1A',
                mb: 1,
                fontWeight: 500
                }}>
                {feature.title}
                </Typography>
                <Typography variant="body1" sx={{ 
                color: '#666',
                lineHeight: 1.6
                }}>
                {feature.description}
                </Typography>
            </Box>
            </Box>
        ))}
        </Box>

      </Box>
    </Box>
  );
};

export default ContentSection; 